export default __webpack_public_path__ + "static/media/sticker-a.23e1e78e.png";